module.exports = __webpack_public_path__ + "img/zhihuiB.c6698315.png";